import { render, staticRenderFns } from "./ImgOrTile.vue?vue&type=template&id=8bef6372&scoped=true&"
import script from "./ImgOrTile.vue?vue&type=script&lang=js&"
export * from "./ImgOrTile.vue?vue&type=script&lang=js&"
import style0 from "./ImgOrTile.vue?vue&type=style&index=0&id=8bef6372&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bef6372",
  null
  
)

export default component.exports